import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { team } from "@/data/content";

const Team = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="team" ref={ref} className="relative bg-fw-navy" data-testid="team-section">
      {/* Cinematic full-bleed */}
      <div className="relative h-[70vh] min-h-[420px] overflow-hidden">
        <motion.img
          style={{ y }}
          src={team.images.main}
          alt="Mannschaft der FF Dingharting"
          className="absolute inset-0 h-[116%] w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-fw-navy via-fw-navy/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 mx-auto max-w-7xl px-5 md:px-8 pb-10">
          <Reveal>
            <span className="font-technical uppercase tracking-[0.3em] text-fw-gold text-sm">Mannschaft</span>
            <h2 className="mt-2 font-technical font-black uppercase text-5xl md:text-7xl text-white leading-none">
              {team.title}
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 md:px-8 py-16 md:py-24">
        <div className="grid gap-10 md:grid-cols-2 md:items-center">
          <Reveal>
            <p className="font-heritage italic text-2xl md:text-3xl text-fw-gold">{team.subtitle}</p>
            <p className="mt-5 font-body text-lg text-white/70">{team.text}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="border-2 border-fw-gold/50 p-2">
              <img
                src={team.images.group}
                alt="Gruppenfoto"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Team;
